export default     {
    prompt:"Button Font",
    field:"buttonFont",
    type:"childStyle",
    child:".e-button",
    valueType:"string",
    fontSelector:true,
    default:"inherit",
    property:"font-family"
}